import { render, staticRenderFns } from "./index.vue?vue&type=template&id=febd3820&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=febd3820&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febd3820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('febd3820')) {
      api.createRecord('febd3820', component.options)
    } else {
      api.reload('febd3820', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=febd3820&scoped=true", function () {
      api.rerender('febd3820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechatOpenPlatform/miniProgramVersion/index.vue"
export default component.exports